<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main">
        <div>
          <br>
          <b-tabs v-model="tabIndex" lazy>
            <b-tab v-for="(t, i) in tabs" :key="i" :title="t.title">
              <component :is="t.comp" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";

import Bank from "./Bank.vue";
import BankAccountList from "./BankAccountList.vue";
import CostCenter from "./CostCenter.vue";
import TypePayment from "./TypePayment.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfigFinanceiroView",
  components: { Panel, Bank, BankAccountList, CostCenter, TypePayment },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        { title: "Banco", comp: Bank },
        { title: "Categoria", comp: CostCenter },
        { title: "Conta Bancária", comp: BankAccountList },
        { title: "Tipo de Pagamento", comp: TypePayment },
      ],
      panel: {
        module: "Financeiro",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  created() {
    const saved = this.get_FilterStorage(this.$route.name);
    this.tabIndex =
      saved && typeof saved.tabIndex === "number" ? saved.tabIndex : this.tabIndex;

    this._addFilterStorage({ routeName: this.$route.name, tabIndex: this.tabIndex });
  },
  watch: {
    tabIndex(val) {
      this._addFilterStorage({ routeName: this.$route.name, tabIndex: val });
    },
  },
  computed: {
    ...mapGetters("generic", ["get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["_addFilterStorage", "removeLoading"]),
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
};
</script>
